// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		suggestionPosition: 'right',
		suggestionMobileStyle: 'style3'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    // Start Boost 186890
    var inputValue;
  
    SearchInput.prototype.beforeRender = function() {
      inputValue = this.$element.val()
    }
    
    SearchInput.prototype.afterRender = function() {
      var currentValue = this.$element.val();
      
      if (!currentValue && inputValue) this.$element.val(inputValue);
    }
    // End Boost 186890

// start 187417
InstantSearchApi.beforeCall = function(searchTerm) {
	Globals.instantSearchQueryParams.h_options = [];
	if(Shopify.country){
		var currentCountry = Shopify.country.toLowerCase();
		Globals.instantSearchQueryParams.h_options.push('exclude_'+currentCountry);
	}
}      
// end 187417
})();